function form() {
    // -------------------------- FORM AJAX
    const formSubmit = (e) => {
        e.preventDefault()

        const formFinish = (data) => {
            elSendHolder.classList.remove('hidden');
            elSendingHolder.classList.add('hidden');
            elButton.disabled = false

            if (data.type && data.type === 'success') {
                elMessage.classList.add('success');
                elMessage.innerHTML = data.messages;
            } else {
                elMessage.classList.add('error');
                if (data.type) {
                    elMessage.innerHTML = data.messages;
                } else {
                    elMessage.innerHTML = '<ul><li>Erroor AJAX sending form!</li></ul>';
                }
            }

            // Remove Messages and Send button to prevent double sending
            setTimeout(() => {
                elMessage.innerHTML = '';
                elButton.remove();
            }, 5000)
        }

        const elSendHolder = e.target.querySelector('.submit-send-holder');
        const elSendingHolder = e.target.querySelector('.submit-sending-holder');
        const elButton = e.target.querySelector('.btn-submit');
        const elMessage = e.target.parentElement.querySelector('.form-message');

        if (elSendingHolder.classList.contains('hidden')) {

            elButton.disabled = true;
            elSendHolder.classList.add('hidden');
            elSendingHolder.classList.remove('hidden');

            axios({
                method: 'post',
                url: e.target.getAttribute('action'),
                data: new FormData(e.target),
                headers: {'Content-Type': 'multipart/form-data' }
            })
                .then(function (response) {
                    //console.log('Success', response.data);
                    formFinish(response.data);
                })
                .catch(function (response) {
                    formFinish(response.data);
                });
        }
    }

    const elForms = document.getElementsByClassName('form-callback');

    Array.from(elForms).forEach(function(element) {
        element.addEventListener('submit', formSubmit);
    });

}

module.exports = {form}
